import { Button } from "@/pages/newHome/ui/button";
import { Card } from "@/pages/newHome/ui/card";
import platform1 from "@/assets/newHome/image-18136.png";
import platform2 from "@/assets/newHome/image-18137.png";
import platform3 from "@/assets/newHome/image-18118.png";
import platform4 from "@/assets/newHome/image-18116.png";
import platform5 from "@/assets/newHome/image-18119.png";
import platform6 from "@/assets/newHome/image-18120.png";
// import ScheduleDemo from "@/features/onboarding/login/Schedule-demo";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const IntegrationByAnima = (): JSX.Element => {
  const navigate = useNavigate();
      // const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
      const user = useSelector(
        (state: RootState) => state.rootReducer.userReducer.user
      );
    
  const integrationPlatforms = [
    { id: 1, src: platform1, alt: "Integration platform" },
    { id: 2, src: platform2, alt: "Integration platform" },
    { id: 3, src: platform3, alt: "Integration platform" },
    { id: 4, src: platform4, alt: "Integration platform" },
    { id: 5, src: platform5, alt: "Integration platform" },
    { id: 6, src: platform6, alt: "Integration platform" },
  ];

  return (
    <section className="w-full bg-gradient-to-b from-white to-[#eefff2] py-8 md:py-20 px-4 pointer-events-auto">
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        {/* Header */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-charcoal text-center mb-6 sm:mb-12">
          Integrates with Everything
        </h2>

        {/* Platform Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-4 gap-y-4 sm:gap-y-6 w-full max-w-5xl mb-8 sm:mb-12">
          {integrationPlatforms.map((platform) => (
            <div key={platform.id} className="flex justify-center"> {/* Wrapper div to center cards */}
              <Card className="w-full h-full max-w-[120px] sm:max-w-[170px] md:max-w-[200px] lg:max-w-[220px] bg-white rounded-lg sm:rounded-2xl border border-gray-300 flex items-center justify-center p-2 sm:p-3 aspect-square">
                {/* Image with responsive sizing */}
                <img
                  src={platform.src}
                  alt={platform.alt}
                  className="object-contain w-[50px] sm:w-[60px] md:w-[80px] lg:w-[100px] h-auto"
                />
              </Card>
            </div>
          ))}
        </div>

        {/* Button */}
        {/* <ScheduleDemo>
          <Button className="px-6 h-[50px] py-3 sm:px-8 sm:py-4 rounded-full bg-primary hover:bg-[#239e41] text-white text-lg sm:text-xl">
            Get Started
          </Button>
        </ScheduleDemo> */}
         <Button
                      onClick={(e) => {
                        if (user) {
                          e.preventDefault();
                          navigate("/dashboard/explore_leads");
                        } else {
                          // window.open("https://buildmapper.typeform.com/to/oVrzJex7", "_blank");
                          //  window.open(`${window.location.origin}/newOnboarding`, "_self");
                            navigate("auth/signup")
                        }
                      }}
                      className="sm:w-40 h-[50px] rounded-[40px] bg-primary hover:bg-[#239e41] shadow-none text-[16px] md:text-lg sm:text-xl font-medium text-white"
                    >
                      Get Started
                    </Button>
      </div>
    </section>
  );
};
